import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M22 12c0-5.522-4.477-10-10-10C6.478 2 2 6.478 2 12c0 4.991 3.656 9.129 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.239.194 2.239.194v2.462h-1.261c-1.243 0-1.63.77-1.63 1.56V12h2.773l-.443 2.891h-2.33v6.988C18.343 21.129 22 16.99 22 12Z",
        }),
      ]
    )
  );
}
